'use strict';
/* global Bun -- Bun case */
module.exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-bun.js
// module id = 709
// module chunks = 0